import React from 'react';
import ErrorMsg from '../components/ErrorMsg';

const Language = ({
  language,
  onConstChange,
  onFunChange,
  onPredChange,
  onFocus,
  onBlur
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement("h2", null, "Language"), /*#__PURE__*/React.createElement("div", {
    className: "input-group mb-2 input-group-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-group-prepend"
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-group-text",
    id: "basic-addon1"
  }, "Constants")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: `form-control ${language.consts.error ? "is-invalid" : ""}`,
    name: "constants",
    onChange: e => onConstChange(e.target.value),
    onBlur: e => onBlur(e.target.value),
    onFocus: e => onFocus(e.target.value),
    value: language.consts.input
  }), /*#__PURE__*/React.createElement(ErrorMsg, {
    error: language.consts.error,
    input: language.consts.input
  })), /*#__PURE__*/React.createElement("div", {
    className: "input-group mb-2 input-group-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-group-prepend"
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-group-text",
    id: "basic-addon1"
  }, "Functions")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: `form-control ${language.funs.error ? "is-invalid" : ""}`,
    name: "functions",
    onChange: e => onFunChange(e.target.value),
    onBlur: e => onBlur(e.target.value),
    onFocus: e => onFocus(e.target.value),
    value: language.funs.input
  }), /*#__PURE__*/React.createElement(ErrorMsg, {
    error: language.funs.error,
    input: language.funs.input
  })), /*#__PURE__*/React.createElement("div", {
    className: "input-group mb-2 input-group-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-group-prepend"
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-group-text",
    id: "basic-addon1"
  }, "Predicates")), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: `form-control ${language.preds.error ? "is-invalid" : ""}`,
    name: "predicates",
    onChange: e => onPredChange(e.target.value),
    onBlur: e => onBlur(e.target.value),
    onFocus: e => onFocus(e.target.value),
    value: language.preds.input
  }), /*#__PURE__*/React.createElement(ErrorMsg, {
    error: language.preds.error,
    input: language.preds.input
  })));
};

export default Language;